module.exports = __webpack_public_path__ + "img/check_box-24px.fc3d6d4c.svg";